var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import { attr, belongsTo } from '@ember-data/model';

// @ts-expect-error This import is not used directly but is required for TypeScript
// eslint-disable-next-line unused-imports/no-unused-imports

export let SalePriceType = /*#__PURE__*/function (SalePriceType) {
  SalePriceType[SalePriceType["SALE_PRICE_TYPE_DO_NOT_USE"] = 0] = "SALE_PRICE_TYPE_DO_NOT_USE";
  SalePriceType[SalePriceType["SALE_PRICE_TYPE_FIXED_AMOUNT"] = 1] = "SALE_PRICE_TYPE_FIXED_AMOUNT";
  SalePriceType[SalePriceType["SALE_PRICE_TYPE_FIXED_PERCENTAGE"] = 2] = "SALE_PRICE_TYPE_FIXED_PERCENTAGE";
  return SalePriceType;
}({});
let SalePrice = (_dec = belongsTo('item-variation', {
  async: false
}), _dec2 = attr('string'), _dec3 = attr('number', {
  defaultValue: SalePriceType.SALE_PRICE_TYPE_FIXED_AMOUNT
}), _dec4 = attr('legacy-money'), (_class = (_class2 = class SalePrice extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "itemVariation", _descriptor, this);
    _initializerDefineProperty(this, "percentage", _descriptor2, this);
    _initializerDefineProperty(this, "salePriceType", _descriptor3, this);
    _initializerDefineProperty(this, "price", _descriptor4, this);
  }
  static catalogType() {
    return 'SALE_PRICE';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'sale-price'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "itemVariation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "percentage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "salePriceType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { SalePrice as default };